<template lang="pug">
api-form(
  ref="form"
  v-model="formData"
  :fields="extraFields"
  :initial="initial"
  :method="updateProfile"
  :success-callback="successCallback"
  no-reset
  @hook:mounted="$emit('init', { method: $refs.form.save })"
)
  template(#save-btn="props")
    slot(
      name="save-btn"
      v-bind="props"
    )
      div
        template(v-if="!hideSave")
          .mt-3.d-flex.justify-center
            app-button(
              rounded
              :loading="props.loading"
              :disabled="props.invalid || !hasChanges"
              @click="props.action"
            ) Сохранить
            slot(
              name="actions"
              v-bind="props"
            )
</template>

<script>
// Замена старому UserRequirementsForm.vue;

import isEqual from 'lodash/isEqual';
import RegionInput from '@/components/user-redesign/inputs/RegionInput.vue';
import MunicipalityInput from '@/components/user-redesign/inputs/MunicipalityInput.vue';
import SnilsInput from '@/components/user-redesign/inputs/SnilsInput.vue';
import DvSelect from '@/packages/ui/components/inputs/DvSelect.vue';

const USER_FIELDS = {
  region: 'region',
  municipality: 'municipality',
  first_name: 'first_name',
  last_name: 'last_name',
  middle_name: 'middle_name',
  birthday_at: 'birthday_at',
  snils: 'snils',
  class: 'class',
};

const NAME_MAX_LEN = 256;

export default {
  props: {
    fields: {
      type: Object,
      default: () => ({
        region: { required: false },
        municipality: { required: false },
        first_name: { required: true },
        last_name: { required: true },
        middle_name: { required: false },
        birthday_at: { required: false },
        snils: { required: false },
        class: { required: false, variants: [] },
      }),
    },
    hideSave: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: this.value,
    };
  },
  computed: {
    initial() {
      const { fields } = this;
      const { $user } = this;
      const data = {
        ...(fields.region ? { region_id: this.$user?.profile?.region?.id || null } : []),
        ...(fields.municipality ? { municipality_id: this.$user?.profile?.municipality?.id || null } : []),
        ...(fields.first_name ? { first_name: this.$user?.profile?.first_name || '' } : []),
        ...(fields.last_name ? { last_name: this.$user?.profile?.last_name || '' } : []),
        ...(fields.middle_name ? { middle_name: this.$user?.profile?.middle_name || '' } : []),
        ...(fields.birthday_at ? { birthday_at: this.$user?.profile?.birthday_at || '' } : []),
        ...(fields.snils ? { snils: this.$user?.profile?.snils || '' } : []),
      };
      return data;
    },
    userFieldsData() {
      const { formData, mergeRules } = this;

      return {
        [USER_FIELDS.region]: ({ rules, prefix }) => ({
          id: USER_FIELDS.region,
          text: 'Регион',
          value: 'region_id',
          rules,
          component: RegionInput,
          component_attrs: {
            'item-value': 'id',
            'item-text': 'name',
            'hide-details': false,
            prefix,
          },
        }),
        [USER_FIELDS.municipality]: ({ rules, prefix }) => ({
          id: USER_FIELDS.municipality,
          text: 'Муниципалитет',
          value: 'municipality_id',
          rules,
          component: MunicipalityInput,
          component_attrs: {
            'item-value': 'id',
            'item-text': 'name',
            'hide-details': false,
            'region-id': formData.region_id,
            prefix,
          },
        }),
        [USER_FIELDS.first_name]: ({ rules, prefix }) => ({
          id: USER_FIELDS.first_name,
          text: 'Имя',
          value: 'first_name',
          rules: mergeRules(rules, 'onlyCyrillic', `max:${NAME_MAX_LEN}`),
          component: 'app-text-input',
          component_attrs: {
            'hide-details': false,
            prefix,
          },
        }),
        [USER_FIELDS.last_name]: ({ rules, prefix }) => ({
          id: USER_FIELDS.last_name,
          text: 'Фамилия',
          value: 'last_name',
          rules: mergeRules(rules, 'onlyCyrillic', `max:${NAME_MAX_LEN}`),
          component: 'app-text-input',
          component_attrs: {
            'hide-details': false,
            prefix,
          },
        }),
        [USER_FIELDS.middle_name]: ({ rules, prefix }) => ({
          id: USER_FIELDS.middle_name,
          text: 'Отчество',
          value: 'middle_name',
          rules: mergeRules(rules, 'onlyCyrillic', `max:${NAME_MAX_LEN}`),
          component: 'app-text-input',
          component_attrs: {
            'hide-details': false,
            prefix,
          },
        }),
        [USER_FIELDS.birthday_at]: ({ rules, prefix }) => ({
          id: USER_FIELDS.birthday_at,
          value: 'birthday_at',
          text: 'Дата рождения',
          rules,
          component: 'ev-datetime-field',
          hideLabel: true,
          component_attrs: {
            'label-date': 'Дата рождения',
            'hide-details': false,
            'only-date': true,
            'date-props': {
              prefix,
            },
          },
        }),
        [USER_FIELDS.snils]: ({ rules, prefix }) => ({
          id: USER_FIELDS.snils,
          text: 'СНИЛС',
          value: 'snils',
          hideLabel: true,
          rules: mergeRules(rules, 'snils'),
          component: SnilsInput,
          component_attrs: {
            'hide-details': false,
            prefix,
          },
        }),
        [USER_FIELDS.class]: ({ rules, prefix, variants }) => ({
          id: USER_FIELDS.class,
          text: 'Класс',
          value: 'class',
          // hideLabel: true,
          rules: mergeRules(rules),
          component: DvSelect,
          component_attrs: {
            'hide-details': false,
            label: 'Класс',
            defaultLabel: true,
            dense: true,
            height: 40,
            prefix,
            items: variants,
          },
        }),
      };
    },
    extraFields() {
      const { userFieldsData, getRules, getPrefix, getVariants, fields } = this;

      return Object.keys(userFieldsData)
        .map((key) => {
          const fieldValue = fields[key];

          if (!fieldValue) {
            return null;
          }

          const rules = getRules(fieldValue);
          const prefix = getPrefix(fieldValue);
          const variants = getVariants(fieldValue);

          return userFieldsData[key]({ prefix, rules, variants });
        })
        .filter(Boolean);
    },
    hasChanges() {
      const { formData, initial } = this;

      return !isEqual(formData, initial);
    },
  },
  watch: {
    value(val) {
      this.formData = val;
    },
    formData(val) {
      this.$emit('input', val);
      this.$emit('fieldsData', this.getSerializedData(val));
    },
    initial(val, prev) {
      if (JSON.stringify(val) === JSON.stringify(prev)) return;
      const { formData, fields, reset } = this;
      if (
        Object.keys(val).length === Object.keys(fields).length
        && Object.keys(formData).length === Object.keys(fields).length
      ) return;

      if (!isEqual(val, formData)) reset(val);
    },
    hasChanges(val) {
      this.$emit('hasChanges', val);
    },
  },
  created() {},
  methods: {
    mergeRules(...rules) {
      return rules.join('|');
    },
    getRules(params = {}, rules) {
      const { required } = params;
      const rulesList = [...((rules || '').split('|') || [])];

      if (required) {
        rulesList.push('required');
      }

      return rulesList.filter(Boolean).join('|');
    },
    getVariants(params = {}) {
      const { variants } = params;

      return variants || [];
    },
    getPrefix(params = {}) {
      const { required } = params;

      return required ? '*' : '';
    },
    getSerializedData(val) {
      const { userFieldsData } = this;

      return Object.entries(val).reduce((acc, [key, value]) => {
        const last = -1;
        const regex = /^(.+?)(?:_id)?$/;
        const match = key.match(regex);
        const field = match.at(last);
        const data =
          userFieldsData[field]({
            rules: '',
            required: false,
          }) || {};
        const { text } = data;

        return {
          ...acc,
          [key]: {
            text,
            value,
          },
        };
      }, {});
    },
    successCallback() {
      this.$emit('update');
      this.$user.reloadUser();
      this.$toast.success('Профиль обновлен');
    },
    reset(val = null) {
      if (val) {
        this.$refs.form.reset(val);
        return;
      }

      this.$refs.form.reset();
    },
    updateProfile({ data, obs }) {
      const { class: classNumber, ...other } = data;
      const currentData = {
        ...classNumber ? {
          class: classNumber.toString().replace(/[^0-9]/g, ''),
        } : {},
        ...other,
      };
      return this.$rApi.user.updateProfile({ data: currentData, obs });
    },
  },
};
</script>
